const initialState = {
    list: [],
    detail: null,
    paging: {
      start: 0,
      limit: 10
    },
    sorting: {
      field: 'date',
      type: 'desc'
    },
    filters: {
      points: [],
      point: null,
      writeoffreason: null,
      startDate: new Date(),
      endDate: new Date(),
      id: null
    },
    count: 0
};

export default function writeoffs(state = initialState, action) {
    switch(action.type) {
      case 'SET_WRITEOFFS': {
            return {
                ...state,
                list: action.list
            };
      }
      case 'SET_WRITEOFFS_FILTERS': {
        return {
            ...state,
            filters: action.filters
        };
      }
      case 'SET_WRITEOFFS_PAGING': {
        return {
            ...state,
            paging: action.paging
        };
      }
      case 'SET_WRITEOFFS_COUNT': {
        return {
            ...state,
            count: action.count
        };
      }
      case 'SET_WRITEOFF': {
        return {
            ...state,
            detail: action.detail
        };
      }
      default: return state;
      }
  }
